<template>
  <div class="cx-unit-name-filter">
    <n-cx-select
      :items="filterItems"
      :selectedItemIds="selectedItems"
      @update:selectedItemIds="props.updateSelection"
      :activatorPlaceholder="translations.unitNameFilter"
      :multiselect="true"/>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { gettext } from '@/translations/gettext.setup';
import translationService from '@/services/translation.service';
import { Unit } from '@/domain/units/Unit';
import NCxSelect from '@/components/NCxSelect.vue';

const { $gettext } = gettext;

interface Props {
  availableUnits: Unit[],
  selectedUnits: Unit[],
  updateSelection: Function
}

const props = defineProps<Props>();

const filterItems = computed(() => {
  return props.availableUnits
    .map(u => ({
      id: u.uuid,
      title: u.name,
      subtitle: translationService.get(u.entityType)
    }));
});

const selectedItems = computed(() => props.selectedUnits.map(u => u.uuid));

const translations = computed(() => ({
  unitNameFilter: $gettext('Unit names'),
}));
</script>
